import {Redirect} from 'react-router-dom';
import React, {Fragment} from 'react';
import Content from '../common/Content';
import styled from 'styled-components';
import CloseIcon from '../../assets/icons/close.svg';

const StyledContent = styled(Content)`
  padding: 0px;
  margin: ${({theme}) => theme.spacingHorizontal()} ${({theme}) => theme.spacingVertical()};
`;

const BackgroundImage = styled.img`
  background-color: ${({theme}) => theme.black};
  width: 100%;
  height: 100%;
`;

const Icon = styled.img`
  cursor: pointer;
  height: ${({theme}) => theme.spacingHorizontal(2)};
  position: absolute;
  top: ${({theme}) => theme.spacingHorizontal()};
  right: ${({theme}) => theme.spacingVertical()};
`;

const onExitSleepMode = props => {
  props.history.goBack();
};

const GuestPage = props => {
  if (!props.user) {
    return <Redirect to={{pathname: '/login', state: {from: props.location}}} />;
  }
  return (
    <Fragment>
      <StyledContent>
        <BackgroundImage src={require('../../assets/images/guestmode.png')} />
        <Icon src={CloseIcon} onClick={() => onExitSleepMode(props)} />
      </StyledContent>
    </Fragment>
  );
};

export default GuestPage;
